// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"customLoadingSpinner_spinnerWrapper__BXp88","spinner":"customLoadingSpinner_spinner__Yw1sS"};